import { render, staticRenderFns } from "./PaymentBillPayUAnonymo.vue?vue&type=template&id=455619b2&"
import script from "./PaymentBillPayUAnonymo.vue?vue&type=script&lang=js&"
export * from "./PaymentBillPayUAnonymo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports